export const FILTER_WIDTH = "100%";
export const FILTER_HEIGHT = 40;
export const MARGIN_BOTTOM = 12;
const POP_UP_WIDTH = 484;
export const POP_UP_HEIGHT = 205;
export const SINGLE_COUNTRY = 1;
